import { useRef } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';

import { useStores } from '../../stores/useStores';
import { Loader } from '../Loader/Loader';

import classes from './GameIframe.module.scss';
import { useGameIframeEvents } from './hooks/useGameIframeEvents';

const GameIframe = observer(() => {
  const { gameStore } = useStores();
  const location = useLocation();

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const { isIframeLoading, onGameIframeError } = useGameIframeEvents({ iframeRef });

  const { gameUiUrl, isGameUiError } = gameStore;

  const isInGamePath = location.pathname.startsWith('/games');

  if (!gameUiUrl || isGameUiError) {
    return null;
  }

  return (
    <div
      className={classNames(classes.iframeWrapper, {
        [classes.hidden]: !gameStore.showGameUi || !isInGamePath,
      })}
    >
      {(isIframeLoading || !gameStore.slotsGameUiIframe) && (
        <div className={classes.loaderWrapper}>
          <Loader fullScreen />
        </div>
      )}
      <iframe
        ref={iframeRef}
        allow="geolocation *; bluetooth *; accelerometer *; gyroscope *; web-share *; clipboard-write *; clipboard-read *"
        className={classes.iframe}
        data-testid="game-ui-iframe"
        height="100%"
        src={gameUiUrl}
        style={{ border: 'none' }}
        width="100%"
        onError={onGameIframeError}
      />
    </div>
  );
});

export default GameIframe;
